module.exports = __webpack_public_path__ + "media/brands/wartburg-93c89c72.png";